import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'

export const ViewWrapper = styled.div`
  background-color: ${themeColor('modalGrey')};
  overflow-y: scroll;
  flex: 1;
  min-height: 0;
  margin-bottom: 68px;
`

export const AlertContainer = styled.div(
  (props) => `
    background-color: ${themeColor('offWhite', props)};
    padding: 16px 18px 6px;
  `
)

export const ApplyTemplateWrapper = styled.div`
  padding: 16px 18px;
  padding-bottom: 80px;
`

export const ApplyTemplateFooter = styled.div`
  width: 100%;
  border-top: 1px solid ${themeColor('grey')};
  position: fixed;
  bottom: 0;
  padding: 10px 16px 0;
  margin-top: 10px;
  margin-bottom: 0px;
  background: ${themeColor('whitePrimary')};
  text-align: center;
  height: 68px;
`

export const BottomContainer = styled.div`
  margin: 0px 0px 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`

export const StyledSearchSortLabel = styled.div`
  margin-right: 5px;
`

export const NoTemplateResults = styled.div`
  height: 204px;
  width: 100%;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 25px 0;
  text-align: center;
  color: ${themeColor('greyPrimary')};
`
